import { BodyText, Div, Dropdown, Flex, Gutter, Title } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { SalesChannel as SalesChannelTsInterface } from '@cdaas/api-clients/dist/product-service-openapi';

import { SalesChannelErrors } from '../utils';

import styles from './SalesChannel.module.scss';

interface SalesChannelProps {
  salesChannel: SalesChannelTsInterface | undefined;
  setSalesChannelUuid: (salesChannelUuid: string) => void;
  salesChannelsInOrganizationsCountry: SalesChannelTsInterface[];
  errors: SalesChannelErrors | undefined;
}

export default function SalesChannel(props: SalesChannelProps) {
  const { salesChannel, setSalesChannelUuid, salesChannelsInOrganizationsCountry, errors } = props;

  const { t } = useTranslation('organizationForm');

  const salesChannelOptions = salesChannelsInOrganizationsCountry.map(salesChannel => {
    return { label: salesChannel.name, value: salesChannel.uuid || '' };
  });
  const selectedSalesChannel = salesChannelOptions.find(option => salesChannel && salesChannel?.uuid === option.value);

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('sales_channel.sales_channel')}</Title>
      <Flex directionColumn className={styles['customer-organization-form__sales-channel__sales-channel-inputs-container']}>
        <Gutter size="layout-5" />
        <BodyText size="sm">{t('sales_channel.sales_channel_info')}</BodyText>
        <Gutter size="layout-5" />
        <Flex alignBottom>
          <Dropdown
            label={t('sales_channel.sales_channel_input_label')}
            name="salesChannel"
            selectedOption={selectedSalesChannel}
            options={salesChannelOptions}
            onChange={(e, salesChannelOption) => {
              setSalesChannelUuid(salesChannelOption.value);
            }}
            required={true}
            errorText={errors?.salesChannel}
          />
        </Flex>
      </Flex>
      <Gutter size="layout-5" />
      <BodyText size="sm">{t('sales_channel.pims_info')}</BodyText>
    </Div>
  );
}
